import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/oauth/amazon")({
  component: AmazonCallback,
  head: () => ({
    meta: [
      { title: "Autorisation Amazon Business · Thiia" },
      {
        name: "description",
        content: "Retour d'autorisation Amazon Business pour la récupération des factures.",
      },
      { property: "og:title", content: "Autorisation Amazon Business · Thiia" },
      {
        property: "og:description",
        content: "Retour d'autorisation Amazon Business pour la récupération des factures.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

/** Page de retour de la popup Amazon : renvoie le code à la fenêtre d'origine. */
function AmazonCallback() {
  const { t } = useTranslation();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      source: "thiia-amazon-oauth",
      code: params.get("code"),
      error: params.get("error_description") ?? params.get("error"),
    };
    try {
      window.opener?.postMessage(payload, window.location.origin);
    } catch {
      /* fenêtre d'origine indisponible */
    }
    setDone(true);
    const timer = window.setTimeout(() => window.close(), 800);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background px-6">
      <div className="flex items-center gap-3 text-[15px] text-muted-foreground">
        {!done && <Loader2 className="h-4 w-4 animate-spin" />}
        <span>{t("settings.integrations.amazon.callbackDone")}</span>
      </div>
    </div>
  );
}
